import React, { ComponentType } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";

/**
 * Wraps a route's element so unauthenticated users are redirected to Auth0's
 * login page automatically. Use it in App.tsx Routes:
 *   <Route path="..." element={<AuthenticationGuard component={Sessions} />} />
 */
export const AuthenticationGuard: React.FC<{
  component: ComponentType;
}> = ({ component }) => {
  const Component = React.useMemo(
    () =>
      withAuthenticationRequired(component, {
        onRedirecting: () => (
          <div className="min-h-screen flex items-center justify-center text-sm text-slate-500">
            Loading…
          </div>
        ),
      }),
    [component]
  );

  return <Component />;
};
